import { doRequest } from 'src/lib/axios/axios-config'

export async function getChatInfoByChatUuidApi({ chatUuid }) {
  try {
    const response = await doRequest.get({
      url: `/chat/${chatUuid}`,
    })
    return response
  } catch (e) {
    console.log('🚀 ~ getChatInfoByChatUuidApi ~ e:', e?.response)
    return e
  }
}
